import { useEffect, useState } from 'react';
import { getUsers, isMissingTable } from '../services/adminApi';
import DataTable from '../components/DataTable';
import StatusBadge from '../components/StatusBadge';
import MissingTable from '../components/MissingTable';

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : '—';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const load = async () => {
      const { data, error } = await getUsers();
      setUsers(data);
      setError(error);
      setLoading(false);
    };
    load();
  }, []);

  if (error && isMissingTable(error)) return <MissingTable table="users" />;

  const q = search.trim().toLowerCase();
  const shown = q
    ? users.filter(
        (u) =>
          (u.full_name || '').toLowerCase().includes(q) ||
          (u.email || '').toLowerCase().includes(q) ||
          (u.phone || '').includes(q)
      )
    : users;

  return (
    <div>
      <div className="page-head">
        <h1>Customers</h1>
        <input
          className="search-input"
          placeholder="Search name, email, phone…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {error && !isMissingTable(error) && (
        <p className="admin-error">Failed to load users: {error.message}</p>
      )}

      <DataTable
        loading={loading}
        emptyMessage={q ? 'No customers match your search.' : 'No customers yet.'}
        columns={[
          {
            key: 'full_name',
            label: 'Name',
            render: (u) => (
              <div>
                <div className="cell-title">{u.full_name || '—'}</div>
                <div className="cell-sub">{u.email || ''}</div>
              </div>
            ),
          },
          { key: 'phone', label: 'Phone' },
          {
            key: 'planet',
            label: 'Planet',
            render: (u) =>
              u.planet ? `${u.planet} (${u.birth_number ?? '–'})` : '—',
          },
          {
            key: 'birth_date',
            label: 'Birth Date',
            render: (u) => fmtDate(u.birth_date),
          },
          {
            key: 'role',
            label: 'Role',
            render: (u) => <StatusBadge status={u.role || 'customer'} />,
          },
          {
            key: 'created_at',
            label: 'Joined',
            render: (u) => fmtDate(u.created_at),
          },
        ]}
        rows={shown}
      />
    </div>
  );
}
